export default {"src":"/_next/static/media/Youtube.32e1601a.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};